<div class="swiper-container-outer">
<div #swiperWrapper class="swiper-container" [swiper]="config" [(index)]="index" (indexChange)="indexChangeHandler($event)">
        <div class="swiper-button-holder">
            <button mat-raised-button class="app-dark-theme app-swiper-button-prev" color="primary"><mat-icon>keyboard_arrow_left</mat-icon></button>
        </div>
        <div class="swiper-wrapper">
            <app-slide class="swiper-slide" *ngFor="let item of items" [item]=item [imageSrc]=item.image_file [thumbHeight]="150">
            </app-slide>
        </div>

        <div class="swiper-button-holder">
            <button mat-raised-button class="app-dark-theme app-swiper-button-next" color="primary"><mat-icon>keyboard_arrow_right</mat-icon></button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/product-carousel/product-carousel.component.html